import { render, staticRenderFns } from "./StokEslemeManuel.vue?vue&type=template&id=2d1f157a"
import script from "./StokEslemeManuel.vue?vue&type=script&lang=js"
export * from "./StokEslemeManuel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports